import React from 'react'
import { UploadIcon } from './UploadIcon'
import app from 'xadmin'
import { C } from 'xadmin-ui'

const IconPicker = props => {
  const { input: { name, value, onChange }, label, meta, field } = props
  const icons = app.get('icons')
  const ifMedia = app.apps.find(item => item.name === 'iot.media') // 判断是否加载媒体库模块
  return <div style={{ display: 'flex' }}>
    <UploadIcon onChange={onChange} value={value} imgList={icons} iconType={'menuIcon'} />
    {
      ifMedia && <C
        is='MediaModal'
        uploadHidden
        uploadType='img'
        input={{
          value: value ? '/rest' + value : value,
          onChange: val => onChange(val?.replace('/rest', ''))
        }}
      />
    }
  </div>
}

export default IconPicker